module.exports = __webpack_public_path__ + "img/ImageGalleryPreviousIcon.3449891d.png";